'use client';

import '@ui5/webcomponents/dist/ToggleButton.js';
import { ButtonDesign, ButtonType } from '../../enums/index.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * The `ToggleButton` component is an enhanced `Button` that can be toggled between pressed and normal states. Users can use the `ToggleButton` as a switch to turn a setting on or off. It can also be used to represent an independent choice similar to a check box.
 *
 * Clicking or tapping on a `ToggleButton` changes its state to `pressed`. The button returns to its initial state when the user clicks or taps on it again. By applying additional custom CSS-styling classes, apps can give a different style to any `ToggleButton`.
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/main-ToggleButton)
 */
const ToggleButton = withWebComponent('ui5-toggle-button', ['accessibleName', 'accessibleNameRef', 'design', 'icon', 'tooltip', 'type'], ['pressed', 'disabled', 'iconEnd', 'submits'], [], ['click']);
ToggleButton.displayName = 'ToggleButton';
ToggleButton.defaultProps = {
  design: ButtonDesign.Default,
  type: ButtonType.Button
};
export { ToggleButton };